import { useState } from "react"
import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import CostRefundCard from "./views/CostRefundCard"
import { useGetCostRefundsQuery, useUpdateCostRefundStatusMutation } from "./api/costRefundApiSlice"
import PaginationBar from "components/widget/PaginationBar"


const CostRefunds = () => {

    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const [requestPage, setRequestPage] = useState(0)

    // API
    const {
        data: response,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetCostRefundsQuery(requestPage)

    // API
    const [updateCostRefund, updateCostRefundResult] = useUpdateCostRefundStatusMutation()

    const handleAccept = (guid) => {
        updateCostRefund({
            guid,
            newStatus: "ACCEPTED"
        })
    }

    let content = <>
        {
            isSuccess &&
            <>
                <div className="row row-cols-1 row-cols-md-3 g-4">
                    {
                        response.content.map(refund => (
                            <CostRefundCard
                                key={refund.guid}
                                refund={refund}
                                administrable={true}
                                onAccept={() => handleAccept(refund.guid)}
                            />
                        ))}
                </div>
                <PaginationBar
                    currentPage={requestPage + 1}
                    postsPerPage={response.pageable.pageSize}
                    totalPosts={response.totalElements}
                    paginate={(e) => {
                        console.log(e)
                        setRequestPage(e - 1)
                    }}
                />
            </>
        }
    </>

    return <PageLayout
        pageTitle={t("absenceReport:menu.cost_refunds")}
        bodyContent={content}
        onPageRefresh={refetch}
        isError={isError}
        errorMsg={error}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching}
    />

}

export default CostRefunds